import { format } from "date-fns";
import { ValidarMembresia } from "../utils/ValidarMembresia.js";
import ReCAPTCHA from "react-google-recaptcha";
import MyRecaptcha from "../components/pago/myRecaptcha.jsx";

const Pago = ({
  evento,
  info,
  setInfo,
  onChange,
  onClick,
  required,
  loading,
  me,
  membresia,
  cupon,
  apCupon,
  setApCupon,
  creditPaymentMethods,
  debitPaymentMethods,
  setRecaptcha,
  recaptchaError,
  requestError,
  isChecked,
  setIsChecked
}) => {
  const disabledInfoCard = false //evento.info.total > 0 ? false : true;
  return (
    <div className="container-md min-vh-100 py-4">
      <div className="d-flex justify-content-center align-items-center px-1 px-md-0">
        <div className="row w-100">
          <div className="col-md-8 col-12 position-relative placeholder-glow">
            <div
              className={`justify-content-center align-items-center
              placeholder placeholder-lg ${loading ? " d-flex " : " d-none "}`}
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                zIndex: 3,
              }}
            ></div>
            {/* Sección Métodos de Pago */}
            <div className="mb-4 bg-light p-2" style={{ borderRadius: "20px" }}>
              <div className="d-none alert alert-info m-2" role="alert" style={{ fontSize: "14px", borderRadius: "10px" }}>
                <strong>Importante:</strong> Si vas a pagar con Mercado Pago, no es necesario rellenar la información de la tarjeta. Solo completa tus datos personales y haz clic en "Pagar con Mercado Pago".
              </div>
              <h3 className="GothamBold p-2 mb-3" style={{ fontSize: "18px" }}>
                Métodos de Pago
              </h3>
              <div className="mb-2 p-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={"debito"}
                    name="tipo"
                    onChange={(e) => onChange(e)}
                    disabled={disabledInfoCard}
                  />
                  <label
                    className="form-check-label fw-medium text-dark"
                    for="flexRadioDefault1"
                  >
                    Débito
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={"credito"}
                    name="tipo"
                    onChange={(e) => onChange(e)}
                    disabled={disabledInfoCard}
                  />
                  <label
                    className="form-check-label fw-medium text-dark"
                    for="flexRadioDefault2"
                  >
                    Crédito
                  </label>
                </div>
                {required.debito_credito && (
                  <span className="text-danger fw-bold">
                    Selecciona que tarjeta estás utilizando
                  </span>
                )}
              </div>

              <div className={`mb-2 p-2 ${info.credito ? "" : "d-none"}`}>
                <div className="form-check w-100 p-0">
                  <select
                    className="form-select py-2 border-dark"
                    disabled={disabledInfoCard}
                    style={{ borderRadius: "10px", fontSize: "12px" }}
                    name="payment_method_id"
                    onChange={(e) => onChange(e)}
                  >
                    <option selected>Selecciona un método de pago</option>
                    {creditPaymentMethods.map((paymentMethod) => {
                      return (
                        <option value={paymentMethod.value}>
                          {paymentMethod.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {required.payment_method_id && (
                  <span className="text-danger fw-bold">
                    Selecciona un método de pago válido
                  </span>
                )}
              </div>

              <div className={`mb-2 p-2 ${info.debito ? "" : "d-none"}`}>
                <div className="form-check w-100 p-0">
                  <select
                    className="form-select py-2 border-dark"
                    disabled={disabledInfoCard}
                    style={{ borderRadius: "10px", fontSize: "12px" }}
                    name="payment_method_id"
                    onChange={(e) => onChange(e)}
                  >
                    <option selected>Selecciona un método de pago</option>
                    {debitPaymentMethods.map((paymentMethod) => {
                      return (
                        <option value={paymentMethod.value}>
                          {paymentMethod.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {required.payment_method_id && (
                  <span className="text-danger fw-bold">
                    Selecciona un método de pago válido
                  </span>
                )}
              </div>
            </div>

            {/* Sección Información de la Tarjeta */}
            <div className="mb-4 bg-light p-2" style={{ borderRadius: "20px" }}>
              <h3 className="GothamBold p-2 mb-3" style={{ fontSize: "18px" }}>
                Información de la Tarjeta
              </h3>
              <div className="mb-2 p-2">
                <label
                  for="exampleFormControlInput1"
                  className="form-label fw-medium text-dark"
                >
                  Número de tarjeta
                </label>
                <input
                  type="text"
                  className="form-control py-2 border-dark"
                  style={{ borderRadius: "10px", fontSize: "12px" }}
                  placeholder=""
                  value={info.numero}
                  name="numero"
                  onChange={(e) => onChange(e)}
                  required
                  disabled={disabledInfoCard}
                />
                <span
                  className={`text-danger fw-bold ${!required.numero ? "d-none" : ""
                    }`}
                >
                  El número de la tarjeta es obligatorio
                </span>
              </div>

              <div className="mb-2 p-2">
                <label
                  for="exampleFormControlInput1"
                  className="form-label fw-medium text-dark"
                >
                  Nombre y Apellido
                </label>
                <input
                  type="text"
                  className="form-control py-2 border-dark"
                  name="titular"
                  value={info.titular}
                  onChange={(e) => onChange(e)}
                  style={{ borderRadius: "10px", fontSize: "12px" }}
                />
                <span
                  className={`text-danger fw-bold ${!required.titular ? "d-none" : ""
                    }`}
                >
                  El nombre y apellido del titular es obligatorio
                </span>
              </div>
              <div className="d-md-flex p-2">
                <div className="mb-2 me-2">
                  <label
                    for="exampleFormControlInput1"
                    className="form-label fw-medium text-dark"
                  >
                    Fecha de vencimiento
                  </label>
                  <div className="d-flex gap-2">
                    <div className="w-50">
                      <select
                        className="form-select py-2 border-dark"
                        name="mes"
                        value={info.mes}
                        onChange={(e) => onChange(e)}
                        style={{ borderRadius: "10px", fontSize: "12px" }}
                        disabled={disabledInfoCard}
                      >
                        <option value="">Mes</option>
                        {Array.from({ length: 12 }, (_, i) => (
                          <option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                            {String(i + 1).padStart(2, '0')}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-50">
                      <select
                        className="form-select py-2 border-dark"
                        name="año"
                        value={info.año}
                        onChange={(e) => onChange(e)}
                        style={{ borderRadius: "10px", fontSize: "12px" }}
                        disabled={disabledInfoCard}
                      >
                        <option value="">Año</option>
                        {Array.from({ length: 26 }, (_, i) => {
                          const year = 2025 + i;
                          const sortYear = 25 + i;
                          return (
                            <option key={year} value={sortYear}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <span
                    className={`text-danger fw-bold ${!required.mes && !required.año ? "d-none" : ""
                      }`}
                  >
                    La fecha de vencimiento es obligatoria
                  </span>
                </div>

                <div className="mb-2 me-2">
                  <label
                    for="exampleFormControlInput1"
                    className="form-label fw-medium text-dark"
                  >
                    Código de seguridad
                  </label>
                  <input
                    className="form-control py-2 border-dark"
                    style={{ borderRadius: "10px", fontSize: "12px" }}
                    type="password"
                    maxlength="7"
                    name="codigo"
                    onChange={(e) => onChange(e)}
                    onFocus={(e) => setInfo({ ...info, focusCVV: true })}
                    onBlur={(e) => setInfo({ ...info, focusCVV: false })}
                    disabled={disabledInfoCard}
                  />
                  <span
                    className={`text-danger fw-bold ${!required.codigo ? "d-none" : ""
                      }`}
                  >
                    El código de seguridad es obligatorio
                  </span>
                </div>

                <div className="mb-2">
                  <label
                    for="exampleFormControlInput1"
                    className="form-label fw-medium text-dark"
                  >
                    DNI
                  </label>
                  <input
                    className="form-control py-2 border-dark"
                    style={{ borderRadius: "10px", fontSize: "12px" }}
                    type="text"
                    maxlength="9"
                    name="dni"
                    onChange={(e) => onChange(e)}
                    disabled={disabledInfoCard}
                  />
                  <span
                    className={`text-danger fw-bold ${!required.dni ? "d-none" : ""
                      }`}
                  >
                    El DNI es obligatorio
                  </span>
                </div>
              </div>
            </div>

            {/* Sección Datos Personales */}
            <div className="mb-4 bg-light p-2" style={{ borderRadius: "20px" }}>
              <h3 className="GothamBold p-2 mb-3" style={{ fontSize: "18px" }}>
                Datos Personales
              </h3>
              <span className="p-2 d-block mb-3 text-muted">
                Lo vamos a utilizar para enviarte tu entrada o contactarte en caso
                de que sea necesario.
              </span>
              <div className="mb-2 p-2">
                <label
                  for="exampleFormControlInput1"
                  className="form-label fw-medium text-dark"
                >
                  E-Mail
                </label>
                <input
                  type="text"
                  className="form-control py-2 border-dark"
                  style={{ borderRadius: "10px", fontSize: "12px" }}
                  name="email"
                  defaultValue={info.email}
                  onChange={(e) => onChange(e)}
                />
                <span
                  className={`text-danger fw-bold ${!required.email ? "d-none" : ""
                    }`}
                >
                  El mail es necesario para recibir tus entradas!
                </span>
              </div>
              <div className="mb-2 p-2">
                <label
                  for="exampleFormControlInput1"
                  className="form-label fw-medium text-dark"
                >
                  Teléfono
                </label>
                <input
                  type="text"
                  className="form-control py-2 border-dark"
                  style={{ borderRadius: "10px", fontSize: "12px" }}
                  name="telefono"
                  defaultValue={info.telefono}
                  onChange={(e) => onChange(e)}
                />
                <span
                  className={`text-danger fw-bold ${!required.telefono ? "d-none" : ""
                    }`}
                >
                  El teléfono es necesario para poder contactarte!
                </span>
                {requestError.status && (
                  <div className="alert alert-danger text-danger fw-bold my-3" style={{ fontSize: "16px" }}>
                    {requestError.msg}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-4 bg-light">
            <div
              className="overflow-hidden"
              style={{
                position: "relative",
                width: "100%",
                paddingTop: "100%",
              }}
            >
              <img
                src={`https://antesala.com.ar/assets/img/eventos/${evento.evento.imagen}`}
                alt=""
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>
            <ul className="list-group bg-transparent">
              <li className="list-group-item border-0 bg-transparent">
                <span className="fw-bold">{evento.evento.nombre}</span>
              </li>
              <li className="list-group-item border-0 bg-transparent mb-3">
                <span className="fw-bold">{`${evento.select.fecha} Hora: ${evento.select.hora}`}</span>
                {evento.evento.entradas.map((entrada, index) => {

                  let descuento = null;
                  if (entrada?.membresia) {
                    descuento = entrada.pricexquantity;
                  }

                  if (entrada.quantity > 0) {
                    return (
                      <div className="mb-2" key={index}>
                        <div className="d-flex justify-content-between">
                          <span>{`${entrada.nombre}`}</span>
                          <span></span>
                        </div>
                        <div className={`d-flex justify-content-between ${entrada?.membresia ? 'text-decoration-line-through' : ''}`}>
                          <span>Precio</span>
                          <span>{`ARS ${parseFloat(
                            entrada.precio
                          ).toLocaleString("es-AR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}</span>
                        </div>
                        {
                          entrada?.membresia
                            ? (
                              <div className="d-flex justify-content-between">
                                <span>Precio</span>
                                <span className="">{`ARS ${parseFloat(
                                  descuento
                                ).toLocaleString("es-AR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`}</span>
                              </div>
                            ) : ""
                        }
                        <div className="d-flex justify-content-between">
                          <span>Cantidad</span>
                          <span>{`X ${entrada.quantity}`}</span>
                        </div>
                      </div>
                    );
                  }
                })}
              </li>
              <li className="list-group-item border-0 bg-transparent">
                <div className="d-flex justify-content-between mb-3">
                  <span>Sub Total</span>
                  <span>{`ARS ${parseFloat(evento.info.subTotal).toLocaleString(
                    "es-AR",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}`}</span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span>{`+ Serv (${evento.evento.comisiones.tasa}%)`}</span>
                  <span>{`ARS ${parseFloat(evento.info.serv).toLocaleString(
                    "es-AR",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}`}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span
                    className={`d-flex justify-content-between ${evento.info?.totalCupon
                      ? "text-decoration-line-through"
                      : ""
                      } `}
                  >
                    Total
                  </span>
                  <span
                    className={`${evento.info?.totalCupon
                      ? "text-decoration-line-through"
                      : ""
                      } `}
                  >{`ARS ${parseFloat(evento.info.total).toLocaleString(
                    "es-AR",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )}`}</span>
                </div>
                <div
                  className={`d-flex justify-content-between ${evento.info?.totalCupon ? "" : "d-none"
                    } `}
                >
                  <span className="fw-bold">
                    Total - ({cupon?.data?.descuento}%)
                  </span>
                  <span>{`ARS ${parseFloat(evento.info?.totalCupon).toLocaleString(
                    "es-AR",
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  ) ?? 0.0
                    }`}</span>
                </div>
              </li>

              <li className="list-group-item border-0 bg-transparent d-none">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                  />
                  <label className="form-check-label">Utilizar gift card</label>
                </div>

                <input
                  type="text"
                  className="satin-bright-input"
                  placeholder="CODIGO"
                />
              </li>

              <li
                className={`px-3 py-3 rounded-0 list-group-item p-0 m-0 border-start-0 border-end-0 bg-transparent ${evento?.evento.cupones.length > 0 ? "" : "d-none"
                  }`}
              >
                <label className="btn border border-end-0 border-start-0 border-top-0 border-dark border-bottom-1 p-0 mb-2">
                  ¿Tenés un cupón de descuento?
                  <button
                    className="d-none"
                    onClick={() => setApCupon(!apCupon)}
                  ></button>
                </label>
                <div
                  className={`d-flex justify-content-between ${apCupon ? "" : "d-none"
                    }`}
                >
                  <span className="w-100 d-block GothamBold fs-6">
                    <input
                      type="text"
                      className="d-block py-2 px-2 w-100"
                      style={{
                        border: "1px solid #d0552a",
                        borderRadius: "10px",
                      }}
                      name="cupon"
                      onChange={(e) => onChange(e)}
                      disabled={disabledInfoCard || loading}
                    />
                    <span className="text-muted" style={{ fontSize: "10px" }}>
                      {cupon.msg}
                    </span>
                  </span>
                  <span className="GothamBold fs-5"></span>
                </div>
              </li>

              <li className="list-group-item border-0 bg-transparent">
                {me?.membresias.map((mem) => {
                  if (ValidarMembresia(mem, evento?.evento.entradas)) {
                    return (
                      <div className="w-100">
                        <label
                          className={`d-block btn btn-outline-dark border-custom-naranja ${mem.id == membresia?.id ? "active" : ""
                            }`}
                          style={{ borderRadius: "10px" }}
                        >
                          <span>{mem.name}</span>
                          <span className="d-block">
                            {loading ? (
                              <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                              </div>
                            ) : (
                              ""
                            )}
                          </span>
                          <span
                            className="d-block"
                            style={{ fontSize: "10px" }}
                          >
                            {`Puedes abonar ${mem.limit} ${mem.limit > 1 ? "entradas" : "entrada"
                              }`}
                          </span>

                          <button
                            className="d-none"
                            name={`${mem.id == membresia?.id
                              ? "quitar-membresia"
                              : "abonar-con-membresia"
                              }`}
                            onClick={(e) => onClick(e, mem)}
                          ></button>
                        </label>
                        <span className="GothamBold fs-5"></span>
                      </div>
                    );
                  } else {
                    return (
                      <div className="d-none justify-content-between">
                        <span className="GothamBold fs-6">
                          {`No puedes abonar con membresia en mas de ${mem.limit} entradas`}
                          <label className="d-block btn btn-outline-dark border-custom-naranja disabled">
                            <span>{mem.name}</span>
                            <span
                              className="text-muted d-block"
                              style={{ fontSize: "10px" }}
                            >
                              {`Tienes ${mem.limit} ${mem.limit > 1 ? "beneficio" : "beneficio disponible"
                                }`}
                            </span>
                            <button className="d-none"></button>
                          </label>
                        </span>
                        <span className="GothamBold fs-5"></span>
                      </div>
                    );
                  }
                })}
              </li>
              <li className="list-group-item border-0 bg-transparent">
                {loading ? (
                  <label
                    className="btn btn-custom-naranja text-white py-3 w-100 mb-1 text-nowrap d-flex align-items-center justify-content-center"
                    style={{ borderRadius: "10px" }}
                  >
                    <span className="me-2">
                      <div className="ms-1 spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </span>
                    Procesando pago
                    <button
                      className="d-none"
                      name="pagar"
                      onClick={(e) => onClick(e)}
                    ></button>
                  </label>
                ) : (
                  <label
                    className="btn btn-custom-naranja text-white py-3 w-100 mb-1"
                    style={{ borderRadius: "10px" }}
                  >
                    Pagar
                    <button
                      className="d-none"
                      name="pagar"
                      onClick={(e) => {
                        onClick(e)
                      }}
                    ></button>
                  </label>
                )}

                {loading ? (
                  <label
                    className="d-none btn btn-primary text-white py-3 w-100 mb-1 text-nowrap d-flex align-items-center justify-content-center"
                    style={{ borderRadius: "10px" }}
                  >
                    <span className="me-2">
                      <div className="ms-1 spinner-border spinner-border-sm" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </span>
                    Procesando pago
                    <button
                      className="d-none"
                      name="pagar_mercado_pago"
                      onClick={(e) => onClick(e)}
                    ></button>
                  </label>
                ) : (
                  <label
                    className="d-none btn btn-primary text-white py-3 w-100 mb-1"
                    style={{ borderRadius: "10px" }}
                  >
                    Pagar con Mercado Pago
                    <button
                      className="d-none"
                      name="pagar_mercado_pago"
                      onClick={(e) => {
                        onClick(e)
                      }}
                    ></button>
                  </label>
                )}

                <div className="mb-4 py-3">
                  <ReCAPTCHA
                    sitekey="6LeAUIQsAAAAACd1XmNbNaF5yOmW3_aEqZsI388x"
                    onChange={(token) => setRecaptcha(token)}
                  />
                </div>

                <img
                  src="/assets/img/decidir.png"
                  className="img-fluid"
                  style={{ width: "100px" }}
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid bg-white mt-100 p-4">
        <p className="Grifter m-0" style={{ fontSize: "10px" }}>
          {`© Copyright - 2022 - ${format(
            new Date(),
            "Y"
          ).toString()} | Antesala.`}{" "}
        </p>
      </div>
    </div>
  );
};

export default Pago;
